export const parseUserRoleText = (user) => {
  if (!user || !user.roles || !user.roles.length) return "Unknown";
  return user.roles[0].full_name;
};
